<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <b-overlay
          :show="isPending"
          rounded="sm"
        >
          <b-card>
            <validation-observer ref="simpleRules">
              <b-form @submit.prevent="validationForm">
                <!-- Media -->
                <b-form-group
                  label-for="v-media"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.media.title"
                      :description="labelForm.media.description"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Media"
                  >
                    <div class="d-flex flex-wrap">
                      <ShowImage
                        v-for="(img, index) in mediaFileList"
                        :key="index"
                        class="mr-50 mb-50"
                        :src="img.image_url"
                        :index="index"
                        :set-main="false"
                        :type="img.mime_type"
                        preview-title="Preview Media"
                        @delete="onDeleteImage(img.id)"
                      />
                      <form-image
                        id="input-media"
                        v-model="tmpImg"
                        width-full
                        label="Pilih Media"
                        with-endpoin
                        :accept-type="acceptMedia"
                        @finish="setMediaFile"
                      />
                    </div>
                    <div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                  </validation-provider>
                </b-form-group>

                <!-- Product ID -->
                <b-form-group
                  label-for="v-product"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.product.title"
                      :description="labelForm.product.description"
                      required
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Product"
                    rules="required"
                  >
                    <b-button
                      v-if="!form.product"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="primary"
                      @click="onShowPopupProduct"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">Pilih produk</span>
                    </b-button>

                    <product-item-card
                      v-if="form.product"
                      :data="form.product"
                      :can-delete="isEdit ? false : true"
                      :clamp="2"
                      :with-variant="selectedVariant ? true : false"
                      :variant-data="selectedVariant ? selectedVariant : {}"
                      @delete="removeProduct"
                    />

                    <input
                      v-model="form.sku_id"
                      type="hidden"
                    >

                    <div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                  </validation-provider>
                </b-form-group>

                <!-- Source -->
                <b-form-group
                  label-for="v-source"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.source.title"
                      :description="labelForm.source.description"
                      required
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Source"
                    rules="required"
                  >
                    <b-row>
                      <b-col
                        v-for="(item, index) in sourceList"
                        :key="`list-source-${index}`"
                        cols="auto"
                        class="mb-1"
                      >
                        <b-form-radio
                          v-model="form.source"
                          name="review-source"
                          :value="item.value"
                        >
                          {{ item.title }}
                        </b-form-radio>
                      </b-col>
                    </b-row>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- User ID -->
                <b-form-group
                  v-if="form.source && form.source === 'miniapoly'"
                  label-for="v-user"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.user.title"
                      :description="labelForm.user.description"
                      required
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="User"
                    rules="required"
                  >
                    <v-select
                      v-model="form.user_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="usersList"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Cari User"
                      @close="$store.commit('user/RESET_USER_LIST')"
                      @search="onSearchUser"
                    >
                      <template #option="{ name, photo }">
                        <div class="d-flex align-items-center">
                          <b-avatar
                            variant="primary"
                            :text="initialText(name)"
                            class="align-baseline"
                            :src="linkStaging(photo)"
                          />
                          <span class="ml-1"> {{ name }}</span>
                        </div>
                      </template>
                      <template #no-options="">
                        User tidak ditemukan.
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Name -->
                <b-form-group
                  v-if="form.source !== 'miniapoly'"
                  label-for="v-name"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.name.title"
                      :description="labelForm.name.description"
                      required
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules="required"
                  >
                    <b-form-input
                      id="v-name"
                      v-model="form.name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Star -->
                <b-form-group
                  label-for="v-star"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.star.title"
                      :description="labelForm.star.description"
                      required
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Star"
                    rules="required"
                  >
                    <b-form-rating
                      v-model="form.star"
                      show-clear
                      show-value
                      inline
                      variant="warning"
                      @change="changeStar"
                    />
                    <div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                  </validation-provider>
                </b-form-group>

                <!-- Review -->
                <b-form-group
                  label-for="v-review"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.review.title"
                      :description="labelForm.review.description"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Review"
                  >
                    <b-form-textarea
                      id="v-review"
                      v-model="form.review"
                      rows="3"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Opsional"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Complaint -->
                <b-form-group
                  label-for="v-complaint"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.complaint.title"
                      :description="labelForm.complaint.description"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Kekurangan"
                  >
                    <b-form-textarea
                      id="v-complaint"
                      v-model="form.complaint"
                      rows="3"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Opsional"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <hr class="my-2">

                <h3 class="mb-2">
                  Informasi Lanjutan
                </h3>

                <!-- Hightlight -->
                <b-form-group
                  label-for="v-highlight"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.highlight.title"
                      :description="labelForm.highlight.description"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Hightlight"
                  >
                    <b-form-checkbox
                      id="v-highlight"
                      v-model="form.highlight"
                      :checked="form.highlight"
                      switch
                      inline
                    >
                      Highlight
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Title -->
                <b-form-group
                  v-if="form.highlight"
                  label-for="v-title"
                  label-cols-md="4"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.title.title"
                      :description="labelForm.title.description"
                      :required="form.highlight"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    :rules="form.highlight ? 'required' : ''"
                  >
                    <b-form-input
                      id="v-title"
                      v-model="form.title"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="form.highlight ? '' : 'Opsional'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Tag -->
                <b-form-group
                  v-if="form.highlight"
                  label-for="v-tag"
                  label-cols-md="4"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.label.title"
                      :description="labelForm.label.description"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Label"
                  >
                    <b-form-input
                      id="v-title"
                      v-model="form.label"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Opsional"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Urutan -->
                <b-form-group
                  v-if="form.highlight"
                  label-for="v-tag"
                  label-cols-md="4"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.order.title"
                      :description="labelForm.order.description"
                      required
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Urutan"
                    rules="min_value:1|integer|required"
                  >
                    <b-form-input
                      id="v-title"
                      v-model="form.order"
                      :state="errors.length > 0 ? false : null"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Visibility -->
                <b-form-group
                  label-for="v-publish"
                  label-cols-md="4"
                  label-class="pt-0"
                >
                  <template #label>
                    <FormLabel
                      :title="labelForm.visibility.title"
                      :description="labelForm.visibility.description"
                    />
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Publish"
                  >
                    <b-form-checkbox
                      id="v-publish"
                      v-model="form.is_publish"
                      :checked="form.is_publish"
                      switch
                      inline
                    >
                      Publik
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Button -->
                <div class="d-flex justify-content-end mt-3">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    :disabled="isSubmitting"
                  >
                    <b-spinner
                      v-if="isSubmitting"
                      small
                    />
                    {{ isSubmitting ? "Menyimpan" : "Simpan" }}
                  </b-button>
                </div>
              </b-form>
            </validation-observer>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>

    <b-modal
      v-model="isShowPickProduct"
      title="Pilih produk"
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <SearchProduct
          selected-indicator
          :multiple="false"
          :padding-item="true"
          @on-select="initProduct"
        />
        <hr>
        <div v-if="selectedProduct">
          <h5 class="mb-1">
            Pilih Varian
          </h5>

          <div v-if="selectedProduct.variants">
            <v-select
              v-model="selectedVariant"
              label="variant"
              :options="selectedProduct.variants"
              :placeholder="`Tersedia ${selectedProduct.variants.length} Varian`"
              :selectable="(option) => option.stock > 0"
            >
              <template #option="{ variant, price, stock }">
                <b-row align-v="center">
                  <b-col>
                    <h5>{{ variant }}</h5>
                    <p class="text-muted mb-0">
                      {{ toCurrency(price ? price : 0) }}
                    </p>
                  </b-col>
                  <b-col class="text-right">
                    {{ stock ? '' : 'stok habis' }}
                  </b-col>
                </b-row>
              </template>
            </v-select>
          </div>

          <p
            v-else
            class="text-muted"
          >
            Produk ini tidak memiliki varian
          </p>

          <hr class="my-1">

          <div class="text-right">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              :disabled="selectedProduct.variants && !selectedVariant ? true : false"
              @click="onPickProduct"
            >
              Simpan
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BSpinner,
  BOverlay,
  BFormCheckbox,
  BFormTextarea,
  BFormRadio,
  BFormRating,
  BAvatar,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import SearchProduct from '@/layouts/components/custom/SearchProduct.vue'
import ProductItemCard from '@/layouts/components/custom/ProductItemCard.vue'
import FormLabel from '@/layouts/components/custom/FormLabel.vue'
import FormImage from '@/layouts/components/custom/FormImage.vue'
// import FormVideo from '@/layouts/components/custom/FormVideo.vue'
import ShowImage from '@/layouts/components/custom/ShowImage.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    BFormCheckbox,
    BFormTextarea,
    BFormRadio,
    BFormRating,
    BAvatar,

    ValidationProvider,
    ValidationObserver,

    vSelect,
    SearchProduct,
    ProductItemCard,
    FormLabel,
    FormImage,
    // FormVideo,
    ShowImage,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        product: '',
        id_product: '',
        sku_id: '',
        user_id: '',
        star: 5,
        review: '',
        complaint: '',
        is_publish: true,
        source: 'miniapoly',
        name: '',
        title: '',
        label: '',
        order: null,
        media_id: [],
        video_id: [],
        mediaFile: [],
        videoFile: [],
        highlight: false,
      },
      required,
      isPending: false,
      isSubmitting: false,
      isShowPickProduct: false,
      selectedVariant: '',
      selectedProduct: '',
      tmpImg: null,
      tmpVid: null,
    }
  },
  computed: {
    ...mapState('review', ['review', 'sourceList', 'reviewByList', 'labelForm']),
    ...mapGetters('user', ['usersList']),
    ...mapGetters('products', ['productsList']),
    typeOptions() {
      return this.listTypeOption.filter(ex => ex.active === true).map(el => el.value)
    },
    reviewId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
    isContainVideo() {
      if (this.form.mediaFile.length) {
        return this.form.mediaFile.find(el => el.mime_type.includes('video'))
      }
      return false
    },
    acceptMedia() {
      if (!this.isContainVideo) return ['image/*', 'video/*']
      return ['image/*']
    },
    mediaFileList() {
      if (this.form.mediaFile.length) {
        const video = this.form.mediaFile.filter(el => el.mime_type.includes('video'))
        const images = this.form.mediaFile.filter(el => !el.mime_type.includes('video'))

        return [...video, ...images]
      }
      return []
    },
  },
  async created() {
    this.isPending = true

    if (this.isEdit) {
      await this.getReview({ reviewId: this.reviewId })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('review', ['createReview', 'getReview', 'updateReview']),
    ...mapActions('user', ['getUserList']),
    ...mapActions('products', ['getProducts']),
    onShowPopupProduct() {
      this.selectedProduct = ''
      this.selectedVariant = ''
      this.$store.commit('products/RESET_PRODUCT_SEARCH')
      this.isShowPickProduct = true
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmitting = true

      const userId = this.form.user_id.id
      const productId = this.form.sku_id

      const data = {
        ...this.form,
        user_id: userId,
        media_id: this.mediaFileList.map(el => el.id),
      }

      let respon = ''

      if (!this.isEdit) {
        respon = await this.createReview({ data, idProduct: productId })
      } else {
        respon = await this.updateReview({ reviewId: this.reviewId, data })
      }

      this.isSubmitting = false

      if (respon) this.$router.push('/reviews')
    },
    async onSearchUser(keyword, loading) {
      if (keyword.length) {
        loading(true)
        this.searchUser(loading, keyword, this)
      }
    },
    searchUser: _.debounce((loading, search, that) => {
      that.getUserList({ keyword: search }).finally(() => {
        loading(false)
      })
    }, 500),
    async initProduct(data) {
      this.selectedProduct = await data
      // this.form.id_product = await data.id
    },
    async onPickProduct() {
      if (!this.selectedProduct.variants) {
        this.form.sku_id = await this.selectedProduct.sku_id
      } else {
        this.form.sku_id = await this.selectedVariant.id
      }
      this.form.product = this.selectedProduct
      this.isShowPickProduct = await false
    },
    removeProduct() {
      this.form.product = ''
      this.form.sku_id = ''
      this.selectedProduct = ''
      this.selectedVariant = ''
    },
    // Edit State Only
    fillData() {
      this.form.product = this.review.product
      this.form.id_product = this.review.product.id
      this.form.star = this.review.star
      this.form.review = this.review.review
      this.form.complaint = this.review.complaint
      this.form.is_publish = this.review.is_publish === 1
      this.form.source = !this.review.source ? 'miniapoly' : this.review.source
      this.form.title = this.review.title
      this.form.label = this.review.label

      this.form.user_id = this.review.user ? {
        id: this.review.user.id,
        name: this.review.user.name,
        photo: this.review.user.photo,
      } : ''

      if (this.review.images.length) {
        this.form.media_id = this.review.images.map(el => el.id)
        this.form.mediaFile = this.review.images
      }

      if (this.review.variant) {
        this.selectedVariant = this.review.variant
        this.form.sku_id = this.review.variant.id
      }

      if (this.review.order) this.form.highlight = true

      this.form.name = this.review.name
      this.form.order = this.review.order
    },
    changeStar(value) {
      if (value === null) this.form.star = 0
    },
    async setMediaFile(data) {
      const datas = await JSON.parse(JSON.stringify(data))
      this.form.media_id.push(datas.id)
      await this.form.mediaFile.push(datas)
      this.tmpImg = null
    },
    async onDeleteImage(id) {
      const index = await this.form.mediaFile.findIndex(el => el.id === id)

      this.form.mediaFile.splice(index, 1)
      this.form.media_id.splice(index, 1)
    },
  },
}
</script>
<style lang="scss" scoped>
.video-preview {
  width: 100% !important;
}
</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
